import { api } from "@/lib/api";

export type ImportListKind = "trakt-list" | "imdb-list" | "tmdb-list";

export interface ImportList {
  id: number;
  name: string;
  kind: ImportListKind;
  /** Trakt: `user/slug`. IMDB: `ls012345678`. TMDB: numeric list id. */
  source_url_or_id: string;
  monitored: boolean;
  enabled: boolean;
  last_synced_at: string | null;
  hit_count: number;
  created_at: string;
  updated_at: string;
}

export interface CreateImportListRequest {
  name: string;
  kind: ImportListKind;
  source_url_or_id: string;
  monitored?: boolean;
  enabled?: boolean;
}

export interface UpdateImportListRequest {
  name?: string;
  kind?: ImportListKind;
  source_url_or_id?: string;
  monitored?: boolean;
  enabled?: boolean;
}

export interface SyncOutcome {
  import_list_id: number;
  total_seen: number;
  added: number;
  already_present: number;
  unresolved: number;
  failed: number;
}

export const importListsApi = {
  list: () => api<ImportList[]>("/api/v1/import-lists"),
  get: (id: number) => api<ImportList>(`/api/v1/import-lists/${id}`),
  create: (body: CreateImportListRequest) =>
    api<ImportList>("/api/v1/import-lists", {
      method: "POST",
      body: JSON.stringify(body),
    }),
  update: (id: number, body: UpdateImportListRequest) =>
    api<ImportList>(`/api/v1/import-lists/${id}`, {
      method: "PATCH",
      body: JSON.stringify(body),
    }),
  remove: (id: number) =>
    api<void>(`/api/v1/import-lists/${id}`, { method: "DELETE" }),
  syncNow: (id: number) =>
    api<SyncOutcome>(`/api/v1/import-lists/${id}/sync-now`, {
      method: "POST",
    }),
};
